import { useEffect, useState } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  FocusLock,
  Text,
  PopoverCloseButton,
  useDisclosure,
  VStack,
  Textarea,
  Button,
} from "@chakra-ui/react";
import StarRating from "../StarRating";

export const RatePopover = ({ onSend, defaultRating = 0, defaultComment = "" }) => {
  const { onOpen, onClose, isOpen } = useDisclosure();

  const [rating, setRating] = useState(defaultRating);
  const [comment, setComment] = useState(defaultComment);

  useEffect(() => {
    setRating(defaultRating);
    setComment(defaultComment);
  }, [defaultRating, defaultComment]);

  const onSelectReview = (value) => {
    setRating(value);

    onOpen();
  };

  const onSubmit = () => {
    onSend(rating, comment);

    onClose();
  };

  return (
    <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} placement="bottom-start">
      <PopoverTrigger>
        <div>
          <StarRating rating={rating} setRating={onSelectReview} size={30} count={5} />
        </div>
      </PopoverTrigger>

      <PopoverContent
        p={5}
        border="0.125rem solid black"
        shadow="-0.3rem 0.3rem black"
        bg="white"
        borderRadius={10}
      >
        <FocusLock returnFocus persistentFocus={false}>
          <PopoverCloseButton />

          <VStack alignItems="flex-start">
            <Text>Leave a review</Text>

            <Textarea
              placeholder="Leave a review..."
              resize="none"
              size="md"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />

            <Button colorScheme="blue" ml="auto" onClick={onSubmit}>
              Send
            </Button>
          </VStack>
        </FocusLock>
      </PopoverContent>
    </Popover>
  );
};
